import { parseISO, format } from 'date-fns';
import { formatDecimalAsPercentage } from 'ns_libs/formatter';
import { IProFormaGeneralInfo, IOperatingAndPermanentDebtInfo, IOperatingPeriodCashFlows } from 'views/ProFormaTable/types';
import { ProFormaModelIds } from 'constants/proForma';
import { OperationsEntity } from 'views/ProFormaTable/constants';
import { IMonthlyAnalysisPeriod } from './MonthlyAnalysisTable/MonthlyAnalysisTable';

export const getMonthlyAnalysisPeriods = (
    proForma: IProFormaGeneralInfo,
    cashFlowPeriods: string[],
    operatingInfo: IOperatingAndPermanentDebtInfo,
    operatingPeriodCashFlows: (IOperatingPeriodCashFlows | null)[],
) => {
    if (!operatingInfo.operationBeginMonth) {
        return [{
            periodName: 'MON YEAR',
            periodDate: '',
            leasedPercentage: '—',
            economicOccupancyPercentage: '—',
        }];
    }
    const monthlyAnalysisPeriods: IMonthlyAnalysisPeriod[] = cashFlowPeriods.map((periodStartDate, index) => {
        let leasedPercentage = '—';
        let economicOccupancyPercentage = '—';
        if (operatingInfo.operationStartDate && cashFlowPeriods.length === operatingPeriodCashFlows.length) {
            const cashFlowPeriod = operatingPeriodCashFlows[index];

            leasedPercentage = formatDecimalAsPercentage(cashFlowPeriod?.leasedPercentage || 0, 2);
            economicOccupancyPercentage = formatDecimalAsPercentage(cashFlowPeriod?.economicOccupancyPercentage || 0, 2);
        }
        return ({
            periodName: format(parseISO(periodStartDate), 'MMM yyyy'),
            periodDate: periodStartDate,
            leasedPercentage,
            economicOccupancyPercentage,
        });
    });

    return monthlyAnalysisPeriods;
};

export const getStabilizedMonthMissingEntity = (proForma: IProFormaGeneralInfo, isEstimate: boolean) => {
    let missingEntity = OperationsEntity.UNIT_MIX;
    if (![ProFormaModelIds.APARTMENT, ProFormaModelIds.APARTMENT_WITH_RETAIL].includes(proForma.proFormaModelId)) {
        if (isEstimate) {
            missingEntity = OperationsEntity.FLOOR_ALLOCATIONS;
        } else {
            missingEntity = OperationsEntity.TENANTS;
        }
    }
    return missingEntity;
};
